// live production url

const api = 'https://api-q66a.onrender.com/api/v1/'
const agroUserUrl = 'https://agrotraemarketplace.com/'
const companyUrl = 'https://agrotraemarketplace.com/company'
const adminUrl = 'https://agrotraemarketplace.com/admin'

// test localhost url

// const api = 'http://localhost:80/api/v1/'
// const agroUserUrl = 'http://localhost:80/api/v1/'
// const companyUrl = 'http://localhost:80/company'
// const adminUrl = 'http://localhost:80/admin'

export default {
  api,
  agroUserUrl,
  companyUrl,
  adminUrl,
}
